import { RenderCamera } from "@rhinov/savane-js";
import { CameraEntityController } from "../CameraEntityController";
import { EntityWidget } from "./EntityWidget";

 export class CameraEntityWidget extends EntityWidget{

    declare controller: CameraEntityController;

    launchRenderPreview = (event: MouseEvent) => {
        this.controller.launchRender((event.currentTarget as HTMLButtonElement & { param?: boolean}).param!);
    }

    constructor(entity: RenderCamera, panel: any, deliverable: any) {
        super(entity, panel, deliverable);
        this.controller = new CameraEntityController(entity, panel, deliverable);
        this.propertiesTab = ['plusLess', 'dropDown', 'dropDown', 'plusLess', 'plusLess', 'dropDown', 'dropDown', 'buttonToggle', 'plusLess', 'plusLess',
            'plusLess', 'range', 'plusLess', 'buttonToggle', 'plusLess', 'range', 'range', 'range', 'plusLess', 'launchRender', 'launchPreview'];
        this.controller.propertiesTab = this.propertiesTab;
    }

    launchRender(property: any): string {
        if (this.controller.decorationDoneAllowed()) {
            return `
                <!-- launch preview & render -->
                <div class="property-item padding ${property.key}">
                    <div class="nopadding">
                        <button id="launchRender" type="button" class="btn btn-flat btn-primary borderless"
                            style="background:#286090" translate>
                            Lancer un rendu
                        </button>
                    </div>
                </div>
            `;
        }
        return "";
    }

    setlaunchRenderListener() {
        let button = document.getElementById('launchRender') as HTMLButtonElement & { param?: boolean};
        if (button) {
            button.param = false;
            button.addEventListener('click', this.launchRenderPreview)
        }
    }

    removelaunchRenderListener() {
        let button = document.getElementById('launchRender');
        if (button) {
            button.removeEventListener('click', this.launchRenderPreview)
        }
    }

    launchPreview(property: any): string {
        if (this.controller.decorationDoneAllowed()) {
            return `
                <!-- launch preview & render -->
                <div class="property-item padding ${property.key}">
                    <div class="nopadding">
                        <button id="launchPreview" type="button" class="btn btn-flat btn-primary borderless"
                            style="background:#286090" translate>
                            Preview rapide
                        </button>
                    </div>
                </div>
            `;
        }
        return "";
    }

    setlaunchPreviewListener() {
        let button = document.getElementById('launchPreview') as HTMLButtonElement & { param?: boolean};
        if (button) {
            button.param = true;
            button.addEventListener('click', this.launchRenderPreview)
        }
    }

    removelaunchPreviewListener() {
        let button = document.getElementById('launchPreview');
        if (button) {
            button.removeEventListener('click', this.launchRenderPreview);
        }
    }


    html(): string {
        var i;
        var html = this.nameHeader() + this.propertyStart();
        for (i = 0; i < this.propertiesTab.length; i++) {
            html += (this as any)[this.propertiesTab[i]](this.panel.properties[i]);
        }

        return html + this.propertyEnd();
    }
}